"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rest;

var _setup = require("./_setup.js");

// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array, n, guard) {
  return _setup.slice.call(array, n == null || guard ? 1 : n);
}